/* eslint-disable no-console */
import { Auth } from 'aws-amplify';

function getIdToken() {
	return Auth.currentSession().then((data) => data.getIdToken().getJwtToken()).catch((err) => console.log(err));
}

function getAccessToken() {
	return Auth.currentSession().then((data) => data.getAccessToken().getJwtToken()).catch((err) => console.log(err));
}

function getRefreshToken() {
	return Auth.currentSession().then((data) => data.getRefreshToken().token).catch((err) => console.log(err));
}

function signOut() {
	return Auth.signOut()
		.then(() => {
			window.location.reload();
		})
		.catch((err1) => {
			console.log(err1);
			window.location.reload();
			// TODO: need a story to show the error on error messages list and show it in on UI
		});
}

function getCurrentAuthenticatedUser() {
	return Auth.currentAuthenticatedUser()
		.then((user) => {
			if (!user.attributes) {
				signOut();
			}
			return user;
		})
		.catch((err) => {
			console.log(err);
			if (err === 'not authenticated') {
				signOut();
			}
		});
}

export default {
	getCurrentAuthenticatedUser,
	getIdToken,
	getAccessToken,
	getRefreshToken,
	signOut
};
